<template>
  <div>
    <h4
      class="mb-3 word-bold"
      :class="titleNoprint"
    >
      <font-awesome-icon
        :icon="titIcon"
        class="mr-2"
      />
      {{ titText }}
    </h4>
    <hr :class="titleNoprints">
  </div>
</template>

<script>
export default {
  props: {
    titPrint: {
      type: String,
      default: ''
    },
    titPrints: {
      type: String,
      default: ''
    },
    titIcon: {
      type: String,
      default: ''
    },
    titText: {
      type: String,
      default: ''
    }
  },
  computed: {
    titleNoprint () {
      return this.titPrint === 'true' ? `no-print` : ''
    },
    titleNoprints () {
      return this.titPrints === 'true' ? `no-print` : ''
    }
  }
}
</script>
